import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './routes/Home/Home';
import ThankYou from './routes/ThankYou/ThankYou';
import { HelpScout } from './components/Helpscout/Beacon';

class App extends Component {
  render() {
    return (
      <div className="App">
        <HelpScout />
        <Router>
          <Switch>
            <Route exact path="/thank-you" component={ThankYou} />
            <Route path="/" component={Home} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js